import { Identifiable, Resource } from "@planzone/dto";
import { LinkedResource, Linker } from "../linkers/types";
import { HttpClient, HttpMethods } from "../types/httpClient";

function editResource(httpClient: HttpClient, linker: Linker) {
  return (resource: Identifiable<Resource>, nextResource: Resource) =>
    httpClient
      .sendHttpRequest<LinkedResource<Identifiable<Resource>>>({
        endpoint: `/resources/${resource.uuid}`,
        method: HttpMethods.PATCH,
        data: {
          role: nextResource.role ? `roles/${nextResource.role.uuid}` : null,
          organizationalUnit: nextResource.organizationalUnit
            ? `organizational-units/${nextResource.organizationalUnit.uuid}`
            : null,
          name: nextResource.name,
          profession: nextResource.profession,
          description: nextResource.description,
          affiliation: nextResource.affiliation,
          ...(!!nextResource.attributes && {
            attributes: nextResource.attributes,
          }),
        },
      })
      .then(linker.linkResource)
      .then((linkedResource) => ({
        ...linkedResource,
        organizationalUnit: nextResource.organizationalUnit,
      }));
}

export { editResource };
